import * as yup from 'yup';
import { TranslateFn } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/**
 * One field, because how long the session ran is the service's own duration and typing it
 * a second time could only disagree with it.
 *
 * The check used to be an imperative `if` inside the confirm handler, which is why the
 * dialog only ever spoke up after a press that failed.
 */
export const createRecordSessionSchema = (translate: TranslateFn) => yup.object({
    startedAt: yup.string()
        .required(translate(ResourcesIds.PURCHASE_RECORD_SESSION_TIME_REQUIRED)),
});

export interface RecordSessionFormValues {
    /** Local wall clock, as `<input type="datetime-local">` reads it. */
    startedAt: string;
}
